import React, { useState } from "react";
import api from "../../services/api";
import { displayMessage } from "../../services/helper";
const DownloadButton = ({ id, fileName, downloadField, downloadedFileName, file }) => {
  const [downloadState, setDownloadState] = useState({
    isDownloading: false,
    progress: 0,
    completed: false
  });

  const handleDownload = () => {
    setDownloadState({ isDownloading: true, progress: 0, completed: false });
    
    api.exercise.download(id, file, 
      { field: downloadField }, 
      {
        onDownloadProgress: (progressEvent) => {
          if (progressEvent.total) {
            const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
            setDownloadState(prev => ({ ...prev, progress: percentCompleted }));
          }
        }
      }
    )    
    .then(response => {
      const blob = new Blob([response.data], { type: response.headers['content-type'] });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `${fileName}.${response.headers['content-type'].split('/')[1]}`;
      a.setAttribute('download', downloadedFileName);
      document.body.appendChild(a);
      a.click();
  
      setDownloadState({ isDownloading: false, progress: 100, completed: true });
      
      setTimeout(() => {
        window.URL.revokeObjectURL(url);
        document.body.removeChild(a);
        
        setTimeout(() => {
          setDownloadState({ isDownloading: false, progress: 0, completed: false });
        }, 2000);
      }, 500);
      alert(displayMessage("DOWNLOAD_FINISHED"),"success")
    })
    .catch(error => {
      console.error(error);
      setDownloadState({ isDownloading: false, progress: 0, completed: false });
      if (error.response.status === 404){
        alert(displayMessage("DOWNLOAD_NOT_FOUND"),"error")
        return
      }
    });
  };

  if (downloadState.isDownloading) {
    return (
        <div className="w-full">
          <div className="h-5 w-full bg-gray-200 rounded overflow-hidden">
            <div 
              className="h-full bg-green-500 transition-all duration-300"
              style={{ width: `${downloadState.progress}%` }}
            ></div>
          </div>
          <div className="text-center text-xs mt-1">
            {downloadState.progress}%
          </div>
        </div>
      );
  }
  
  if (downloadState.completed) {
    return (
        <div className="text-green-500 font-bold flex items-center justify-center">
          {displayMessage('DOWNLOAD_FINISHED')}
        </div>
      );
  }

  return <button onClick={handleDownload} className="px-3 py-1 bg-blue-500 text-white rounded hover:bg-blue-600 transition-colors">{fileName || 'download'}</button>;
};

export default DownloadButton;